import React from "react";
import AccountModalHeader from "./AccountModalHeader";
import ConnectedAccountForm from "./ConnectedAccountForm";
import AccountModalFooter from "./AccountModalFooter";
import "./AccountModalContent.scss";

const AccountModalContent = () => (
    <div className="account-modal-content">
        <div className="account-modal-content__container">
            <AccountModalHeader />
            <ConnectedAccountForm />
            <AccountModalFooter />
        </div>
    </div>
);

export default AccountModalContent;
